module.exports = __webpack_public_path__ + "static/media/ic_blik.a723731a.svg";